/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_sign_in = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const zh_hans1_settings_sign_in = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const zh_hant1_settings_sign_in = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入`)
};

const fr_settings_sign_in = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const de_settings_sign_in = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const ja_settings_sign_in = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const ko_settings_sign_in = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_sign_in = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_sign_in(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_sign_in", locale)
	if (locale === "en") return en_settings_sign_in(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_sign_in(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_sign_in(inputs)
	if (locale === "fr") return fr_settings_sign_in(inputs)
	if (locale === "de") return de_settings_sign_in(inputs)
	if (locale === "ja") return ja_settings_sign_in(inputs)
	return ko_settings_sign_in(inputs)
};